/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsAppListItem
 */
export interface DigitizingserviceMelcoDigitizingModelsAppListItem {
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsAppListItem
     */
    product_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsAppListItem
     */
    name?: string | null;
}

export function DigitizingserviceMelcoDigitizingModelsAppListItemFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsAppListItem {
    return DigitizingserviceMelcoDigitizingModelsAppListItemFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsAppListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsAppListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function DigitizingserviceMelcoDigitizingModelsAppListItemToJSON(value?: DigitizingserviceMelcoDigitizingModelsAppListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'product_code': value.product_code,
        'name': value.name,
    };
}


